/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, keywords, title, ogImage, ogURL, ogTitle, ogDescription, metaTitle, metaDescription, metaCategory, metaPrice, metaStock, twitterDescription, }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s`}
      meta={[
        {
          name: `generator`,
          content: `Flotiq.com`
        },
        {
          name: `title`,
          content: metaTitle,
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `category`,
          content: metaCategory,
        },
        {
          name: `price`,
          content: metaPrice,
        },
        {
          name: `stock`,
          content: metaStock,
        },
        {
          property: `og:title`,
          content: ogTitle,
        },
        {
          property: `og:description`,
          content: ogDescription,
        },
        {
          property: `fb:app_id`,
          content: '2876870939077453',
        },
        {
          property: `og:image:alt`,
          content: ogTitle,
        },
        {
          property: `og:image`,
          content: ogImage,
        },
        {
          property: `og:image:width`,
          content: '400',
        },
        {
          property: `og:image:height`,
          content: '300',
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:url`,
          content: ogURL,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: twitterDescription,
        },
      ]
        .concat(
          keywords.length > 0
            ? {
              name: `keywords`,
              content: keywords.join(`, `),
            }
            : []
        )
        .concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
  description: ``,
  metaTitle: ``,
  metaCategory: ``,
  metaDescription: ``,
  metaPrice: ``,
  metaStock: ``,
  ogTitle: ``,
  ogDescription: ``,
  ogImage: ``,
  ogURL: ``,
  twitterDescription: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  metaTitle: PropTypes.string.isRequired,
  metaCategory: PropTypes.string.isRequired,
  metaDescription: PropTypes.string,
  metaPrice: PropTypes.string.isRequired,
  metaStock: PropTypes.string,
  ogTitle: PropTypes.string.isRequired,
  ogDescription: PropTypes.string.isRequired,
  ogImage: PropTypes.string.isRequired,
  ogURL: PropTypes.string.isRequired,
  twitterDescription: PropTypes.string,
}

export default SEO
